import React from 'react';
import { Card, Checkbox, Space, Button, Tag, Tooltip } from 'antd';
import { DeleteOutlined, CrownOutlined, CarOutlined, UserOutlined, PlusOutlined } from '@ant-design/icons';
import { Typography } from 'antd';

const { Text } = Typography;

const CompactStaffCard = ({ person, teamIndex, isDriver, isLead, onRoleChange, onRemove, onAddStaff }) => {
    const handleDriverChange = (e) => {
        onRoleChange(teamIndex, person.id, 'driver', e.target.checked);
    };

    const handleLeadChange = (e) => {
        onRoleChange(teamIndex, person.id, 'lead', e.target.checked);
    };

    return (
        <Card
            size="small"
            style={{
                marginBottom: 10,
                borderRadius: 4,
                padding: '0'
            }}
        >
            <Space direction="vertical" style={{ width: '100%' }} size={2}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div>
                        <Text strong style={{ fontSize: '12px', lineHeight: '1.2' }}>
                            <UserOutlined style={{ marginRight: 4, fontSize: 10 }} />
                            {person.firstname} {person.lastname}
                        </Text>
                    </div>

                    <div style={{ position: 'absolute', right: '10px' }}>
                        <Tooltip title="Удалить из команды" key="delete">
                            <Button
                                type="text"
                                danger
                                size="small"
                                icon={<DeleteOutlined />}
                                onClick={onRemove}
                                style={{ height: 24, width: 24, minWidth: 24 }}
                            />
                        </Tooltip>
                    </div>
                </div>
                <div>
                    <Checkbox
                        checked={isDriver}
                        onChange={handleDriverChange}
                        style={{ margin: 0, fontSize: '11px' }}
                    >
                        Водитель
                    </Checkbox>
                    <Checkbox
                        checked={isLead}
                        onChange={handleLeadChange}
                        style={{ margin: 0, fontSize: '11px' }}
                    >
                        Старший
                    </Checkbox>
                </div>
            </Space>
        </Card>
    );
};

export default CompactStaffCard;